import { readConfiguracoes } from '@/modules/system/configuracoes/configuracoes.service';
import { ConfiguracoesSistema } from '@/modules/business/movimentacoes/enum/configuracoes-sistema.enum';

let cached: boolean | null = null;
let inflight: Promise<boolean> | null = null;

export function parseValorModuloRelatoriosAtividadesHabilitado(valor: string | undefined | null): boolean {
  if (valor == null || valor.trim() === '') {
    return true;
  }
  const v = valor.trim().toLowerCase();
  // Só desliga com valores inequivocamente negativos; qualquer outro texto no BD mantém o módulo visível.
  if (v === 'false' || v === '0' || v === 'no' || v === 'nao' || v === 'não') {
    return false;
  }
  return true;
}

/**
 * Indica se o módulo “Relatórios de Atividades” está habilitado (configuração no servidor).
 * Resultado é cacheado até {@link invalidateModuloRelatoriosAtividadesHabilitadoCache}.
 */
export async function getModuloRelatoriosAtividadesHabilitado(): Promise<boolean> {
  if (cached !== null) {
    return cached;
  }
  if (inflight) {
    return inflight;
  }
  inflight = readConfiguracoes()
    .then((rows) => {
      const row = rows.find((r) => r.chave === ConfiguracoesSistema.ModuloRelatoriosAtividadesHabilitado);
      cached = parseValorModuloRelatoriosAtividadesHabilitado(row?.valor);
      return cached;
    })
    .catch(() => {
      cached = true;
      return cached;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function invalidateModuloRelatoriosAtividadesHabilitadoCache(): void {
  cached = null;
  inflight = null;
}
